import React from 'react';

export const LazyLoadedLoginPage = React.lazy(() => import('./auth/LoginPage'));
export const LazyLoadedSignupPage = React.lazy(() =>
  import('./auth/RegisterPage'),
);
export const LazyLoadedForgotPasswordPage = React.lazy(() =>
  import('./auth/ForgotPasswordPage'),
);
export const LazyLoadedResetPasswordPage = React.lazy(() =>
  import('./auth/ResetPasswordPage'),
);
export const LazyLoadedInvitationSignupPage = React.lazy(() =>
  import('./auth/PHAInvitationSignupPage'),
);
export const LazyLoadedOptOutPage = React.lazy(() =>
  import('./app/OptOutPage'),
);
export const LazyLoadedApplicationsPage = React.lazy(() =>
  import('./app/application/ApplicationsPage'),
);
export const LazyLoadedBuildingsPage = React.lazy(() =>
  import('./app/building/PropertiesDataPage'),
);

// Remove later
// export const LazyLoadedOrganizationsPage = React.lazy(() =>
//   import('./app/organization/OrganizationsPageNew'),
// );
// export const LazyLoadedPHAsPage = React.lazy(() => import('./app/phas/index'));
// export const LazyLoadedPHAInvitationsPage = React.lazy(() =>
//   import('./app/PHAInvitations/index'),
// );
// export const LazyLoadedPHAProgrammes = React.lazy(() =>
//   import('./app/PHAProgrammes/index'),
// );
// export const LazyLoadedAgentsListPage = React.lazy(() =>
//   import('./app/organization/members/OrganizationMembersListPage'),
// );
// export const LazyLoadedPhaMemberListPage = React.lazy(() =>
//   import('./app/phas/PhaMembersListPage'),
// );
export const LazyLoadedOrganizationsDataPage = React.lazy(() =>
  import('./app/organization/OrganizationsDataPage'),
);
export const LazyLoadedPHADataPage = React.lazy(() =>
  import('./app/phas/PHADataPage'),
);
export const LazyLoadedPHADetailPage = React.lazy(() =>
  import('./app/phas/PHADetailPage'),
);
export const LazyLoadedEditPHADetailPage = React.lazy(() =>
  import('./app/phas/EditPHADetailPage'),
);
export const LazyLoadedPHACallDetailsPage = React.lazy(() =>
  import('./app/phas/PHACallDetailPage'),
);
export const LazyLoadedViewOrganizationPage = React.lazy(() =>
  import('./app/organization/ViewOrganizationPages'),
);
export const LazyLoadedAddOrganizationPage = React.lazy(() =>
  import('./app/organization/AddOrganizationPage'),
);
export const LazyLoadedSettingPage = React.lazy(() => import('./app/Settings'));
export const LazyLoadedSuggestionsPage = React.lazy(() =>
  import('./app/Suggestions'),
);
export const LazyLoadedSuggestionsBankStatementPage = React.lazy(() =>
  import('./app/support/bank-statement/BankStatementManualEntry'),
);
export const LazyLoadedViewSuggestionsPage = React.lazy(() =>
  import('../components/Dashboard/suggestions/UnitDetail'),
);
export const LazyLoadedNewApplicationsPage = React.lazy(() =>
  import('./app/new-applications/index'),
);
export const LazyLoadedOsmosUploaderPage = React.lazy(() =>
  import('./app/OsmosUploader/index'),
);

export const LazyLoadedUnitsPage = React.lazy(() => import('./app/UnitsPage'));
export const LazyLoadedguestCard = React.lazy(() =>
  import('./app/GuestCardsPage'),
);
export const LazyLoadedReferralsPage = React.lazy(() =>
  import('./app/Referrals/ReferralsPage'),
);
export const LazyLoadedSupportPage = React.lazy(() =>
  import('./app/support/SupportPage'),
);
export const LazyLoadedPropertyPreview = React.lazy(() =>
  import('./preview/PropertyPreview/PropertyPreview'),
);
export const LazyLoadedGuestApply = React.lazy(() =>
  import('./preview/GuestApply/GuestApply'),
);
export const LazyLoadedInsuredApplications = React.lazy(() =>
  import('./app/insuranced-applications/InsurancedApplicationsListPage'),
);
export const LazyLoadedConfigurationPage = React.lazy(() =>
  import('./app/organization/configuration/ConfigurationPage'),
);

export const LazyLoadedSystemLogsPage = React.lazy(() =>
  import('./app/system/index'),
);
// RENTER ROUTES
export const LazyLoadedUploadPhaVoucherPage = React.lazy(() =>
  import('./renter/UploadPhaVoucherPage'),
);
export const LazyLoadedUploadGovtIdPage = React.lazy(() =>
  import('./renter/UploadGovtIdPage'),
);
export const LazyLoadedUploadCoApplicantsPage = React.lazy(() =>
  import('./renter/UploadCoApplicantsPage'),
);
export const LazyLoadedPaymentDetailsPage = React.lazy(() =>
  import('./renter/PaymentDetailsPage'),
);
export const LazyLoadedUploadCRSPage = React.lazy(() =>
  import('./renter/crs/UploadCRSPage'),
);
export const LazyLoadedUploadCRSPageNew = React.lazy(() =>
  import('./renter/crs/UploadCRSPageNew'),
);
export const LazyLoadedUploadBankStatementPage = React.lazy(() =>
  import('./renter/bank-statements/index'),
);
export const LazyLoadedUploadPayStubPage = React.lazy(() =>
  import('./renter/payrolls'),
);
export const LazyLoadedUploadTaxReturnPage = React.lazy(() =>
  import('./renter/UploadTaxReturnPage'),
);
export const LazyLoadedUploadResidenceHistoryPage = React.lazy(() =>
  import('./renter/UploadResidenceHistoryPage'),
);
export const LazyLoadedTermAndConditionPage = React.lazy(() =>
  import('./renter/TermAndConditionPage'),
);
export const LazyLoadedExtendedAppTermAndConditionPage = React.lazy(() =>
  import('./renter/ExtendedAppTermAndConditionPage'),
);

export const LazyLoadedExtendedAppAdditionalInformationPage = React.lazy(() =>
  import('./renter/extended-app-additional-info/CombinedApplicationForm'),
);

export const LazyLoadedSubmissionPage = React.lazy(() =>
  import('./renter/SubmissionPage'),
);

export const LazyLoadedYourInformationPage = React.lazy(() =>
  import('./renter/YourInformationPage'),
);

export const LazyLoadedConfirmDetailsPage = React.lazy(() =>
  import('./confirm-details/ConfirmDetailsPage'),
);

export const LazyLoadedInsurancePlanPage = React.lazy(() =>
  import('./renter/AllStateInsuranceModal'),
);

// export const LazyLoadedInsurancePage = React.lazy(() =>
//   import('./insurance/insurance-flow/InsurancePage'),
// );

export const LazyLoadedInsurancePage = React.lazy(() =>
  import('./insurance/allstate-flow/AllStateInsurancePage'),
);

export const LazyLoadedSignLeasePage = React.lazy(() =>
  import('./insurance/SignLeasePage/SignLeasePage'),
);

export const LazyLoadedPendingPayrollsPage = React.lazy(() =>
  import('./app/support/shared/PayrollsDocumentsList'),
);

export const LazyLoadedPendingBankStatementsPage = React.lazy(() =>
  import('./app/support/bank-statement/BankStatementsDocumentsList'),
);

export const LazyLoadedPendingPropertiesPage = React.lazy(() =>
  import('./app/support/property/PendingPropertiesList'),
);

// User Routes
export const LazyLoadedProfilePage = React.lazy(() =>
  import('../pages/app/Profile/UserProfilePage'),
);
export const LazyLoadedProfileEditPage = React.lazy(() =>
  import('./app/Profile/EditUserProfilePage'),
);

export const LazyLoadedGetInsurencePage = React.lazy(() =>
  import('./insurance/assurant-flow/pages/AssurantInsurancePage'),
);

// Recertification List Routes
export const LazyLoadedTenantMonitoringPage = React.lazy(() =>
  import('./app/recertification/TenantMonitoringPage'),
);
// Apply
export const LazyLoadedRecertificationApplyPreview = React.lazy(() =>
  import('./preview/RecertificationApplyPreview/RecertificationApplyPreview'),
);
export const LazyLoadedRecertificationPersonalInformationPage = React.lazy(() =>
  import('./app/recertification/apply/PersonalInformationPage'),
);
export const LazyLoadedRecertificationAdditionalInformationPage = React.lazy(
  () => import('./app/recertification/apply/AdditionalInformationPage'),
);
export const LazyLoadedRecertificationGovtIdentificationPage = React.lazy(() =>
  import('./app/recertification/apply/GovtIdentificationPage'),
);
export const LazyLoadedRecertificationBankStatementPage = React.lazy(() =>
  import('./app/recertification/apply/UploadBankStatementPage'),
);
export const LazyLoadedRecertificationPaystubPage = React.lazy(() =>
  import('./app/recertification/apply/UploadPaystubPage'),
);
export const LazyLoadedTermsAndConditionPage = React.lazy(() =>
  import('./app/recertification/apply/TermsAndCondition'),
);
export const LazyLoadedUploadAdditionalDocumentsPage = React.lazy(() =>
  import('./app/recertification/apply/UploadAdditionalDocument'),
);

export const LazyLoadedRecertificationApplicantsPage = React.lazy(() =>
  import('./app/recertification/RecertificationApplicantsListPage'),
);

export const LazyLoadedRecertificationApplicantInvitesListPage = React.lazy(
  () => import('./app/recertification/invites/RecertificationInvitesListPage'),
);
export const LazyLoadedRecertificationDataPage = React.lazy(() =>
  import('./app/recertification/RecertificationDataPage'),
);

export const LazyLoadedHelpPage = React.lazy(() =>
  import('./app/help/HelpPage'),
);
